import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import { AssetsService } from "app/services/AssetsService";

import { StyledSignalsCardEmptyWrapper } from "./styles";

const SignalsCardEmpty = () => {
    return (
        <StyledSignalsCardEmptyWrapper
            flexDirection="column"
            justifyContent="center"
            flexGrow="1"
            padding="0 40px"
            gap="32px"
            minHeight="368px"
        >
            <img
                height="143px"
                src={AssetsService.assetUrl("/images/common/lighthouse.svg")}
            />
            <Text
                fontVariant="h6"
                color={colorsPalettes.carbon[500]}
            >
                {translate("si.company-analysis.signals.card.empty.text")}
            </Text>
        </StyledSignalsCardEmptyWrapper>
    );
};

export default SignalsCardEmpty;
